import qc from 'qc'
import {
  getSceneNodeByNode,
  hadAnimation,
  isCooperateProjectDisableMiniLayout,
  isImportNode,
  isMovedImportNode,
  isVideo,
} from '@ps/bridge/qc/base'
import _ from 'lodash'
import assets from '../assets'
import nodePool from '../node-pool'
import gameIframe from '@ps/bridge/iframe/iframe'
import {
  CoordinateSet,
  rotateShape,
  scaleShape,
  translateShape,
} from '@ps/utils/geometric-transformation'
import { Vector2d } from 'konva/lib/types'
import store from '@ps/store'
import { rad2deg } from '@com/utils/unit-converters/angle'
import shortid from 'shortid'
import { getAnimationType } from '@ps/workbench/animation'
import { isCooperateProject } from '@ps/permission/workbench'
import { getVpAstFromSceneNode } from '../vp'
import { scripts } from '../scripts'
import {
  getEventsOnNode,
  getEventsToNode,
} from '@ps/store/workbench/visual-program'
import { isNormalScene, isPlayScene } from '@ps/bridge/qc/scripts/scene-config'
/**
 * 暂停与重置动画回到起始位置
 */
export function resetAndStopAnimation(node: qc.Node): void {
  if (!hadAnimation(node)) return
  node.scripts.forEach((item, index) => {
    // 倒序遍历列表，保证同类动画reset到同类动画第一个动画的初始状态
    const script = node.scripts[node.scripts.length - 1 - index] as qc.Tween
    if (script.addType === 1) {
      script.resetToBeginning(false)
      script.stop()
    }
  })
  // 如果是新的节点，只有挪动位置才需要更新 layout
  if (isImportNode(node)) {
    if (isMovedImportNode(node)) {
      store.dispatch('workspace/game/screenAdapter/adapterHandlerByElement', {
        node,
      })
    }
  } else {
    // 如果是自研项目，播放动画不自动更新 layout， 不知道为啥之前这里要更新 layout ,先在自研西协同项目验证
    if (!isCooperateProject() || isCooperateProjectDisableMiniLayout()) {
      store.dispatch('workspace/game/screenAdapter/adapterHandlerByElement', {
        node,
      })
    }
  }
}
// 复制节点时,新节点的动画uuid和builtinId需要替换新的
export function replaceAnimationUuid(node: qc.Node): void {
  const sceneNode = getSceneNodeByNode(node)
  let ast = {}
  if (sceneNode) {
    ast = getVpAstFromSceneNode(sceneNode)
  }
  const tweenMethodList = [
    'vpPlayTweenByUuid',
    'vpStopTweenByUuid',
    'vpPlayTweenByUuidGoOn',
    'vpResetTweenPropByUuid',
  ]
  // 事件里的动画id也要替换成新的
  function replaceTweenIdInEvent(oldId: string, newId: string) {
    for (const i in ast) {
      for (const j in ast[i].action) {
        const action = ast[i].action[j]
        if (
          action &&
          action.node === node.uuid &&
          tweenMethodList.indexOf(action.method) > -1 &&
          action.param &&
          action.param.vpTweenUuid === oldId
        ) {
          action.param.vpTweenUuid = newId
        }
      }
    }
  }
  // playsmart.editor.data里的unSplitProp的TweenPosition替换成新的
  function replaceTweenIdInEditorScript(oldId: string, newId: string) {
    const editorData = node.getScript(scripts.editor.name)
    if (editorData && editorData.$data && editorData.$data.unSplitProp) {
      for (const i in editorData.$data.unSplitProp) {
        if (i === `tweenPosition-${oldId}`) {
          editorData.$data.unSplitProp[`tweenPosition-${newId}`] =
            editorData.$data.unSplitProp[`tweenPosition-${oldId}`]
          delete editorData.$data.unSplitProp[`tweenPosition-${oldId}`]
          break
        }
        if (i === `tweenScale-${oldId}`) {
          editorData.$data.unSplitProp[`tweenScale-${newId}`] =
            editorData.$data.unSplitProp[`tweenScale-${oldId}`]
          delete editorData.$data.unSplitProp[`tweenScale-${oldId}`]
          break
        }
      }
    }
  }
  // 替换vh脚本里的tweenPosition和tweenScale的uuid值
  function replaceTweenIdInVHScript(oldId: string, newId: string) {
    const vh = node.getScript(scripts.verticalHorizontal.name)
    if (vh && vh.adapterData) {
      if (vh.adapterData.tweenPosition[oldId]) {
        vh.adapterData.tweenPosition[newId] =
          vh.adapterData.tweenPosition[oldId]
        delete vh.adapterData.tweenPosition[oldId]
      }
      if (vh.adapterData.tweenScale[oldId]) {
        vh.adapterData.tweenScale[newId] = vh.adapterData.tweenScale[oldId]
        delete vh.adapterData.tweenScale[oldId]
      }
    }
  }
  const tweens = node.getScripts('qc.Tween')
  const builtinIdTransform: any = {}
  tweens.forEach((tween) => {
    const newUuid = gameIframe.qcGame.math.uuid()
    const oldUuid = tween.uuid
    tween.uuid = newUuid
    replaceTweenIdInEvent(oldUuid, newUuid)
    replaceTweenIdInEditorScript(oldUuid, newUuid)
    replaceTweenIdInVHScript(oldUuid, newUuid)
    // 组合动画需要替换builtinId
    if (tween.builtinId) {
      const oldUuid = tween.builtinId
      if (builtinIdTransform[tween.builtinId]) {
        tween.builtinId = builtinIdTransform[tween.builtinId]
        replaceTweenIdInEvent(oldUuid, builtinIdTransform[tween.builtinId])
      } else {
        let builtinId = generateBuiltInId()
        builtinId = `${builtinId}___${getAnimationType(tween.builtinGroup)}`
        builtinIdTransform[tween.builtinId] = builtinId
        tween.builtinId = builtinId
        replaceTweenIdInEvent(oldUuid, builtinId)
      }
    }
  })
}

export function generateBuiltInId(): string {
  const uuid = shortid()
  return uuid.replace(/\$/g, 'a') // 组合动画的builtinId中如有$2,事件表的正则编译会有错误,索性把$改成其他字符
}

export function resetToBeginningAfterPlay(
  animations: Array<{ delay: number; duration: number }>,
  node: qc.Node,
): number | null {
  if (animations.length === 0) return null
  const time = Math.max(
    ...animations.map((item) => item.delay * 1000 + item.duration * 1000),
  )
  let timerId = null
  timerId = window.setTimeout(() => {
    resetAndStopAnimation(node)
  }, time + 50) // + 50毫秒的补偿值
  return timerId
}

/**
 * 插入节点
 * @param node 待插入节点
 * @param parent 目标节点
 * @param index 索引
 */
export function addChildAt({
  node,
  parent,
  index,
}: {
  node: qc.Node
  parent: qc.Node
  index?: number
}) {
  parent.addChildAt(node, index || 0)
}

/**
 * 设置节点索引
 * @param node 待调整节点
 * @param index 索引
 */
export function setChildIndex({
  node,
  index,
}: {
  node: qc.Node
  index: number
}): void {
  node.parent.setChildIndex(node, index)
}

/**
 * 拷贝节点
 * @param node 待拷贝节点
 * @param parent 拷贝的父节点
 * @param index 索引
 */
export function clone({
  node,
  parent,
  index,
}: {
  node: qc.Node
  parent: qc.Node
  index?: number
}): qc.Node {
  const qcGame = gameIframe.qcGame
  const cloneNode = qcGame.add.clone(node, parent)
  if (!_.isUndefined(index) && index >= 0) {
    parent.setChildIndex(cloneNode, index)
  }
  return cloneNode
}

/**
 * 获取 qc.node 的世界顶点坐标值
 * @param node
 */
export function getNodeVertexPoint(node: qc.Node): Vector2d[] {
  // 如果是 video 节点，设置 visible 属性会导致视频脚本内部事件触发，导致有声音，因此 video 节点需要用getWorldCorners 来获取顶点坐标
  if (isVideo(node)) {
    return node.getWorldCorners()
  }
  // 直接用 getWorldCorners 的话，在频繁获取时，会获取到旧数据
  const rect = node.rect
  const rectX = rect.x
  const rectY = rect.y
  const rectWidth = rect.width
  const rectHeight = rect.height
  const curVisibleStatus = node.visible
  // node.toGlobal 方法依赖 node.visible 状态，如果元素是隐藏的，需要先显示元素
  if (!curVisibleStatus) {
    node.visible = true
  }
  const p1 = node.toGlobal(<qc.Point>{
    x: rectX,
    y: rectY,
  })
  const p2 = node.toGlobal(<qc.Point>{
    x: rectX + rectWidth,
    y: rectY,
  })
  const p3 = node.toGlobal(<qc.Point>{
    x: rectX + rectWidth,
    y: rectY + rectHeight,
  })
  const p4 = node.toGlobal(<qc.Point>{
    x: rectX,
    y: rectY + rectHeight,
  })
  if (!curVisibleStatus) {
    node.visible = curVisibleStatus
  }
  return [p1, p2, p3, p4]
}

/**
 * 坐标xy的逻辑到ui补偿转换,用于左上角和中心点的坐标转换
 * @param {qc.Node} node
 * @param {number} x 可以为空
 * @param {number} y 可以为空
 */
export function transformXyLogic2Ui(
  node: qc.Node,
  x?: number,
  y?: number,
): { transformX: number; transformY: number } {
  const worldScale = store.state.workspace.game.device.worldScale
  // 如果有世界坐标的 x/y 传参，则赋值获取世界坐标顶点，再回滚, 必须传参 x, y
  if (typeof x !== 'undefined' && typeof y !== 'undefined') {
    node.x = x
    node.y = y
  }
  const nodeVertexPoint = getNodeVertexPoint(node)
  const p1 = nodeVertexPoint[0] as Vector2d
  const transformX = p1.x / worldScale.x
  const transformY = p1.y / worldScale.y
  return { transformX, transformY }
}

/**
 * 获取Atlas节点对应资源id
 * @param node
 */
export function getAtlasUuid(node: qc.Node): string | undefined {
  if (node) {
    return node.texture && node.texture.atlas.uuid
  }
}

/**
 * 更新节点 asset
 * @param nodeUuid 节点id
 * @param resourceUuid 资源id
 */
export async function updateAsset({
  nodeUuid,
  resourceUuid,
}: {
  nodeUuid: string
  resourceUuid: string
}): Promise<qc.Texture | undefined> {
  const asset = assets.findByUUID(resourceUuid)
  const Texture = gameIframe.texture
  const node = nodePool.find(nodeUuid)

  if (!node) return
  if (asset) {
    // @ts-ignore
    node.texture = new Texture(asset, 0)
    return node.texture
  } else {
    const asset = await assets.load({
      uuid: resourceUuid,
      url: String(assets.uuid2UrlConf[resourceUuid]),
    })
    // @ts-ignore
    node.texture = new Texture(asset, 0)
    return node.texture
  }
}

/**
 * 因为存在节点在 group 中，节点的 x/y 都是基于父级，直接通过赋值 x/y 的值会存在问题
 * 可以通过设置世界坐标的方式来移动节点
 * 如果需要获取最新的 x,y 可以通过移动后的节点重新获取 x/y
 * @param node 需要调整的 node 节点
 * @param x 世界坐标 x 值
 * @param y 世界坐标 y 值
 */
export function moveNodeByWorldPosition({
  node,
  x,
  y,
}: {
  node: qc.Node
  x: number
  y: number
}): void {
  const actualLocalPosition = transformWorldPositionToLocal({ node, x, y })
  node.x = actualLocalPosition.x || 0
  node.y = actualLocalPosition.y || 0
}

/**
 * 获取节点世界坐标里面的宽高
 * @param node
 */
export function getNodeSize(node: qc.Node): {
  width: number
  height: number
} {
  const nodeVertexPoint: CoordinateSet[] = getNodeVertexPoint(node).map(
    (item) => {
      return [item.x, item.y]
    },
  )
  const distance = getBoundaryValue(nodeVertexPoint)
  return {
    width: distance[0]![1] - distance[0]![0],
    height: distance[1]![1] - distance[1]![0],
  }
}

/**
 * 获取多个坐标的边界值
 * @param array
 */
export function getBoundaryValue(array: CoordinateSet[]): CoordinateSet[] {
  const distanceY: CoordinateSet = [array[0]![1], array[1]![1]]
  const distanceX: CoordinateSet = [array[0]![0], array[1]![0]]
  array.forEach((coordinate) => {
    if (coordinate[1] < distanceY[0]!) {
      distanceY[0] = coordinate[1]
    }
    if (coordinate[1] > distanceY[1]!) {
      distanceY[1] = coordinate[1]
    }
    if (coordinate[0] < distanceX[0]!) {
      distanceX[0] = coordinate[0]
    }
    if (coordinate[0] > distanceX[1]!) {
      distanceX[1] = coordinate[0]
    }
  })
  return [distanceX, distanceY]
}

/**
 * 获取两个节点之前的距离
 * @param node 节点A
 * @param preNode 节点B
 * @return [x 轴的距离, y 轴的距离]
 */
export function getNodesDistance(
  node: qc.Node,
  preNode: qc.Node,
): CoordinateSet {
  const nodeVertexPoint = getNodeVertexPoint(node).map((item) => {
    return [item.x, item.y]
  })
  const preNodeVertexPoint = getNodeVertexPoint(preNode).map((item) => {
    return [item.x, item.y]
  })
  const [distanceX, distanceY] = getBoundaryValue(
    nodeVertexPoint.concat(preNodeVertexPoint) as CoordinateSet[],
  )
  const nodeRect = getNodeSize(node)
  const preNodeRect = getNodeSize(preNode)
  return [
    distanceX![1] - distanceX![0] - nodeRect.width - preNodeRect.width,
    distanceY![1] - distanceY![0] - nodeRect.height - preNodeRect.height,
  ]
}

/**
 * 通过元素的全局坐标转换成基于父级的本地坐标
 * @param node 元素节点
 * @param x 全局坐标的 x 值
 * @param y 全局坐标的 y 值
 */
export function transformWorldPositionToLocal({
  node,
  x,
  y,
}: {
  node: qc.Node
  x: number
  y: number
}): qc.Point {
  return node.parent.toLocal(new gameIframe.qc.Point(x, y))
}

/**
 * 获取缩放后图形的中心点偏移值
 * @param point 缩放之前的图形坐标
 * @param pivot 缩放、旋转的中心点
 * @param angle 旋转弧度
 * @param scale 缩放的 x/y 系数
 * @param delta 偏移的 x/y 系数
 */
export function getScaleShapeDelta(
  point: CoordinateSet,
  pivot: CoordinateSet,
  angle: number,
  scale: CoordinateSet,
  delta?: CoordinateSet,
): CoordinateSet {
  // 旋转回正常角度，获取旋转之前的坐标值
  const preRotationCoordinate = rotateShape(point, pivot, -angle)
  // 对图形进行缩放
  const afterScaleCoordinate = scaleShape(preRotationCoordinate, pivot, scale)
  // 缩放后重新旋转，获取旋转后的坐标值
  let curCoordinate = rotateShape(afterScaleCoordinate, pivot, angle)
  // 如果涉及偏移值
  if (delta) {
    curCoordinate = translateShape(curCoordinate, delta[0], delta[1])
  }
  return [curCoordinate[0] - point[0], curCoordinate[1] - point[1]]
}

/**
 * @description: 计算canvas渐变起始坐标
 * https://blog.csdn.net/JJHuiQ/article/details/118308025
 * @param {number} canvas width
 * @param {number} canvas height
 * @param {number} angle 角度
 * @return {*}
 */
export function calculateGradientCoordinate(
  width: number,
  height: number,
  angle: number,
) {
  if (angle >= 360) angle = angle - 360
  if (angle < 0) angle = angle + 360
  angle = Math.round(angle)

  // 当渐变轴垂直于矩形水平边上的两种结果
  if (angle === 0) {
    return {
      x0: Math.round(width / 2),
      y0: height,
      x1: Math.round(width / 2),
      y1: 0,
    }
  }
  if (angle === 180) {
    return {
      x0: Math.round(width / 2),
      y0: 0,
      x1: Math.round(width / 2),
      y1: height,
    }
  }

  // 当渐变轴垂直于矩形垂直边上的两种结果
  if (angle === 90) {
    return {
      x0: 0,
      y0: Math.round(height / 2),
      x1: width,
      y1: Math.round(height / 2),
    }
  }
  if (angle === 270) {
    return {
      x0: width,
      y0: Math.round(height / 2),
      x1: 0,
      y1: Math.round(height / 2),
    }
  }

  // 从矩形左下角至右上角的对角线的角度
  const alpha = Math.round(
    (Math.asin(width / Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2))) *
      180) /
      Math.PI,
  )

  // 当渐变轴分别于矩形的两条对角线重合情况下的四种结果
  if (angle === alpha) {
    return {
      x0: 0,
      y0: height,
      x1: width,
      y1: 0,
    }
  }
  if (angle === 180 - alpha) {
    return {
      x0: 0,
      y0: 0,
      x1: width,
      y1: height,
    }
  }
  if (angle === 180 + alpha) {
    return {
      x0: width,
      y0: 0,
      x1: 0,
      y1: height,
    }
  }
  if (angle === 360 - alpha) {
    return {
      x0: width,
      y0: height,
      x1: 0,
      y1: 0,
    }
  }

  // 以矩形的中点为坐标原点，向上为Y轴正方向，向右为X轴正方向建立直角坐标系
  let x0 = 0
  let y0 = 0
  let x1 = 0
  let y1 = 0

  // 当渐变轴与矩形的交点落在水平线上
  if (
    angle < alpha || // 处于第一象限
    (angle > 180 - alpha && angle < 180) || // 处于第二象限
    (angle > 180 && angle < 180 + alpha) || // 处于第三象限
    angle > 360 - alpha // 处于第四象限
  ) {
    // 将角度乘以（PI/180）即可转换为弧度
    const radian = (angle * Math.PI) / 180
    // 当在第一或第四象限，y是height / 2，否则y是-height / 2
    const y = angle < alpha || angle > 360 - alpha ? height / 2 : -height / 2
    const x = Math.tan(radian) * y
    // 当在第一或第二象限，l是width / 2 - x，否则l是-width / 2 - x
    const l =
      angle < alpha || (angle > 180 - alpha && angle < 180)
        ? width / 2 - x
        : -width / 2 - x
    const n = Math.pow(Math.sin(radian), 2) * l
    x1 = x + n
    y1 = y + n / Math.tan(radian)
    x0 = -x1
    y0 = -y1
  }

  // 当渐变轴与矩形的交点落在垂直线上
  if (
    (angle > alpha && angle < 90) || // 处于第一象限
    (angle > 90 && angle < 90 + alpha) || // 处于第二象限
    (angle > 180 + alpha && angle < 270) || // 处于第三象限
    (angle > 270 && angle < 360 - alpha) // 处于第四象限
  ) {
    // 将角度乘以（PI/180）即可转换为弧度
    const radian = ((90 - angle) * Math.PI) / 180
    // 当在第一或第二象限，x是width / 2，否则x是-width / 2
    const x =
      (angle > alpha && angle < 90) || (angle > 90 && angle < 90 + alpha)
        ? width / 2
        : -width / 2
    const y = Math.tan(radian) * x
    // 当在第一或第四象限，l是height / 2 - y，否则l是-height / 2 - y
    const l =
      (angle > alpha && angle < 90) || (angle > 270 && angle < 360 - alpha)
        ? height / 2 - y
        : -height / 2 - y
    const n = Math.pow(Math.sin(radian), 2) * l
    x1 = x + n / Math.tan(radian)
    y1 = y + n
    x0 = -x1
    y0 = -y1
  }

  // 坐标系更改为canvas标准，Y轴向下为正方向
  x0 = Math.round(x0 + width / 2)
  y0 = Math.round(height / 2 - y0)
  x1 = Math.round(x1 + width / 2)
  y1 = Math.round(height / 2 - y1)

  return { x0, y0, x1, y1 }
}

export function getPaddingFromNode(node: qc.Node): number[] {
  return [node.borderLeft, node.borderTop, node.borderRight, node.borderBottom]
}

export function setPaddingToNode(node: qc.Node, val: number[]): void {
  node.borderLeft = Number(val[0])
  node.borderTop = Number(val[1])
  node.borderRight = Number(val[2])
  node.borderBottom = Number(val[3])
}

export const getNodeStyle = ({
  node,
  attrs,
}: {
  node: qc.Node
  attrs: Record<string, any>
}): Record<string, any> | null => {
  if (_.isEmpty(attrs)) return null
  const style = _.pick(node, attrs)
  if (attrs.some((val: string) => val === 'rotation')) {
    style['rotation'] = Number.parseInt(
      rad2deg(style['rotation']).toFixed(0),
      10,
    )
  }
  return style
}

export function getNodesLayoutBySceneId({ sceneId, nodesLayout }) {
  return Object.keys(nodesLayout).reduce((memo, nodeId) => {
    const item = nodesLayout[nodeId]
    if (item.sceneId === sceneId) {
      memo[nodeId] = _.cloneDeep(item)
    }
    return memo
  }, {})
}

export const getRemoveSceneConfig = (scene, nextActiveSceneUUID): any => {
  const AllNodesLayout = store.state.workspace.sceneManager.nodesLayout
  const currentSceneList = isNormalScene(scene)
    ? store.state.workspace.sceneManager.sceneList.filter((item) =>
        isNormalScene(item),
      )
    : store.state.workspace.sceneManager.sceneList.filter((item) =>
        isPlayScene(item),
      )

  const index = currentSceneList.findIndex((item) => {
    return item.uuid === scene.uuid
  })
  const activeNodeList = store.state.workspace.game.activeNodeList
  const activeNode = store.state.workspace.game.activeNode
  const activeUuid = activeNode ? activeNode.uuid : ''
  const nodesLayout = getNodesLayoutBySceneId({
    sceneId: scene.uuid,
    nodesLayout: AllNodesLayout,
  })
  const eventsOnNode = getEventsOnNode({ sceneId: scene.uuid })
  const eventsToNode = getEventsToNode({ nodeId: scene.uuid })
  return {
    newValue: {
      node: scene,
      activeSceneUuid: nextActiveSceneUUID,
      activeUuid,
    },
    oldValue: {
      node: scene,
      parent: scene.parent,
      index,
      activeSceneUuid: scene.uuid,
      activeUuid,
      activeUuids: activeNodeList.map((item) => item.uuid),
      nodesLayout,
      eventsOnNode,
      eventsToNode,
    },
  }
}
